import { Flex, Separator, Box } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import { useColorModeValue } from 'toolkit/chakra/color-mode';
import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';

import DeFiDropdown from './DeFiDropdown';
import NetworkMenu from './NetworkMenu';
import Settings from './settings/Settings';
import TopBarStats from './TopBarStats';
import { useEthers } from '@usedapp/core';

const TopBar = () => {
  const bgColor = useColorModeValue('gray.50', 'whiteAlpha.100');

  const { activateBrowserWallet, deactivate, account, switchNetwork } = useEthers();

  // const connectWallet = async () => {
  //   try {
  //     activateBrowserWallet();
  //     await switchNetwork(159);
  //   } catch (err) {
  //     console.error('Wallet connection error:', err);
  //   }
  // };

  // const truncate = (addr: string) => addr?.slice(0, 6) + '...' + addr?.slice(-4);


  return (
    <Box bgColor={bgColor}>
      <Flex
        py={2}
        px={{ base: 3, lg: 6 }}
        maxW={`${CONTENT_MAX_WIDTH}px`}
        m="0 auto"
        justifyContent="space-between"
        alignItems="center"
      >
        {!config.features.opSuperchain.isEnabled ? <TopBarStats /> : <div />}
        <Flex alignItems="center">
          {config.features.deFiDropdown.isEnabled && (
            <>
              <DeFiDropdown />
              <Separator mr={3} ml={{ base: 2, sm: 3 }} height={4} orientation="vertical" />
            </>
          )}
          <Flex justifyContent="space-between" alignItems="center" columnGap={2} my={3}>
            {/* {!account ? (
              <button
                onClick={connectWallet}
                style={{ backgroundColor: '#38A169', color: 'white', borderRadius: '5px', fontSize: '12px', fontWeight: 'bold', padding: ' 0.25rem 2rem', cursor: 'pointer', transition: 'background-color 0.2s'}}
              >
                Connect Wallet
              </button>
            ) : (
              <Flex justifyContent="space-between" alignItems="center" columnGap={2}>
                <div style={{ backgroundColor: '#38A169', color: 'white', borderRadius: '5px', fontSize: '12px', fontWeight: 'bold', padding: '0.25rem 2rem', cursor: 'pointer', transition: 'background-color 0.2s' }}>
                  <span>{truncate(account)}</span>
                </div>
              </Flex>
            )} */}
            <Settings />
          </Flex>
          {Boolean(config.UI.navigation.featuredNetworks) && (
            <Box display={{ base: 'none', lg: 'flex' }} alignItems="center">
              <Separator mx={3} height={4} orientation="vertical" />
              <NetworkMenu />
            </Box>
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default React.memo(TopBar);
